var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',[_c('r-icon',{attrs:{"name":"close-delete","size":22}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }